import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
const TONES = {
    error: "border-error/40 bg-error/5 text-error",
    success: "border-success/40 bg-success/5 text-success",
    info: "border-line bg-surface text-ink-soft",
    note: "border-gold bg-gold/10 text-ink",
};
export function Alert({ tone = "info", children }) {
    return (_jsx("div", { role: tone === "error" ? "alert" : "status", className: clsx("flex items-start gap-3 rounded-card border px-4 py-3 font-ui text-base leading-relaxed", TONES[tone]), children: children }));
}
